// Sidebar item IDs in priority order per cluster.
// Items not listed for a cluster are hidden from the sidebar.
// Universal items (home, clients, messages, team, money, reports) appear in every cluster.

export type SidebarItemId =
  | 'dashboard' | 'schedule' | 'bookings' | 'jobs' | 'dispatch'
  | 'projects' | 'clients' | 'vendors' | 'messages' | 'services' | 'locations'
  | 'fleet' | 'team' | 'money' | 'reports';

// Per-cluster label overrides (only specify when different from default)
const CLUSTER_LABEL_OVERRIDES: Record<string, Partial<Record<SidebarItemId, string>>> = {
  D: { locations: 'Properties' },
};

export function getClusterLabelOverride(cluster: string, itemId: SidebarItemId): string | undefined {
  return CLUSTER_LABEL_OVERRIDES[cluster]?.[itemId];
}

// Cluster A — Appointment (beauty, wellness, health, education, pet)
const CLUSTER_A: SidebarItemId[] = [
  'dashboard', 'bookings', 'clients', 'vendors', 'messages', 'services',
  'team', 'money', 'reports',
];

// Cluster B — Field Service (construction, home_services, landscaping)
const CLUSTER_B: SidebarItemId[] = [
  'dashboard', 'schedule', 'jobs', 'dispatch', 'projects',
  'clients', 'vendors', 'messages', 'locations', 'fleet',
  'team', 'money', 'reports',
];

// Cluster C — Route/Cleaning (cleaning, pet, care)
const CLUSTER_C: SidebarItemId[] = [
  'dashboard', 'schedule', 'jobs', 'clients', 'vendors', 'messages',
  'services', 'locations', 'fleet',
  'team', 'money', 'reports',
];

// Cluster D — Property/Facilities
const CLUSTER_D: SidebarItemId[] = [
  'dashboard', 'schedule', 'jobs', 'clients', 'vendors', 'messages',
  'locations', 'team', 'money', 'reports',
];

// Cluster E — Event/Project (events, creative, technology)
const CLUSTER_E: SidebarItemId[] = [
  'dashboard', 'schedule', 'jobs', 'projects', 'dispatch',
  'clients', 'vendors', 'messages', 'services', 'locations', 'fleet',
  'team', 'money', 'reports',
];

// Cluster F — Automotive
const CLUSTER_F: SidebarItemId[] = [
  'dashboard', 'bookings', 'jobs', 'clients', 'vendors', 'messages',
  'services', 'fleet', 'team', 'money', 'reports',
];

// Cluster G / fallback — broad set
const CLUSTER_DEFAULT: SidebarItemId[] = [
  'dashboard', 'schedule', 'jobs', 'clients', 'vendors', 'messages',
  'services', 'locations', 'team', 'money', 'reports',
];

const CLUSTER_MAP: Record<string, SidebarItemId[]> = {
  A: CLUSTER_A,
  B: CLUSTER_B,
  C: CLUSTER_C,
  D: CLUSTER_D,
  E: CLUSTER_E,
  F: CLUSTER_F,
  G: CLUSTER_DEFAULT,
};

export function getSidebarItems(cluster: string): SidebarItemId[] {
  return CLUSTER_MAP[cluster] ?? CLUSTER_DEFAULT;
}
